function detectBrowser() {
  const ua = navigator.userAgent;

  if (/Edg/.test(ua)) return "Edge";
  else if (/Chrome/.test(ua)) return "Chrome";
  else if (/Firefox/.test(ua)) return "Firefox";
  else if (/Safari/.test(ua) && !/Chrome/.test(ua)) return "Safari";
  else return "Other";
}

export default detectBrowser;
